import { rootApiSupplyBeam } from '../../api/rootApi';

export const cartonApi = rootApiSupplyBeam.injectEndpoints({
    endpoints: (builder) => ({
        getCartonList: builder.mutation({
            query: ({ token, slug, body }) => ({
                url: 'scans/getAllCartonData',
                method: 'POST',
                headers: {
                    'slug': "32",
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body,
            }),
        }),
        saveCartonInfo: builder.mutation({
            query: ({ token, body }) => ({
                url: 'scans/saveCartonInfo',
                method: 'POST',
                headers: {
                    'slug': "32",
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body,
            }),
        }),
    }),
});

export const { useGetCartonListMutation, useSaveCartonInfoMutation } = cartonApi;
